var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group copy-field"},[_c('input',{ref:"input",staticClass:"form-control",attrs:{"type":"text","readonly":""},domProps:{"value":_vm.content}}),_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.copy}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }